import {ActionType, type Action} from "@khan/guide-types";

import arrowSquareOutIcon from "@phosphor-icons/core/regular/arrow-square-out.svg";
import browsersIcon from "@phosphor-icons/core/regular/browsers.svg";
import copyIcon from "@phosphor-icons/core/regular/copy.svg";
import swapIcon from "@phosphor-icons/core/regular/swap.svg";

interface ActionIconInfo {
    icon: PhosphorRegular | undefined;
    placement?: "start" | "end";
}

/**
 * Returns the icon and the icon's inline location for the _first_ matching action
 * in a list of actions.
 *
 * @param actions - the readonly array of actions to inspect for a matching
 * action.
 * @returns An object containing the icon and information on where the icon
 * should be placed in the line.
 */
export const getActionIcon = (
    actions: ReadonlyArray<Action>,
): ActionIconInfo => {
    if (actions) {
        for (const action of actions) {
            switch (action.actionType) {
                case ActionType.navigation:
                    return {icon: arrowSquareOutIcon, placement: "end"};
                case ActionType.openModal:
                    return {icon: browsersIcon, placement: "end"};
                case ActionType.copyToClipboard:
                    return {icon: copyIcon, placement: "start"};
                case ActionType.replaceHighlightedText:
                    return {icon: swapIcon, placement: "start"};
            }
        }
    }
    return {icon: undefined, placement: undefined};
};
